import React, { Component } from "react";
import { Tabs, Tab } from "react-bootstrap";
import CorredoresCategorias from "../../pages/CorredoresCategorias";
import Produtos from "../../pages/Produtos";
import Destaques from "../../pages/Destaques";
import "./styles.css";

export default class Estoque extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      key: "produtos",
      status: null,
    };
  }

  render() {
    return (
      <Tabs
        id="controlled-tab-example"
        className="tabStyle"
        activeKey={this.state.key}
        onSelect={(key) => this.setState({ key })}
      >
        <Tab eventKey="CorredoresCategorias" title="Corredores e Categorias">
          <CorredoresCategorias />
        </Tab>
        <Tab eventKey="produtos" title="Produtos">
          <Produtos></Produtos>
        </Tab>
        <Tab eventKey="destaques" title="Destaques">
          <Destaques></Destaques>
        </Tab>
      </Tabs>
    );
  }
}
